import { render, staticRenderFns } from "./pageLayout.vue?vue&type=template&id=7bdde8a0"
import script from "./pageLayout.vue?vue&type=script&lang=js"
export * from "./pageLayout.vue?vue&type=script&lang=js"
import style0 from "./pageLayout.vue?vue&type=style&index=0&id=7bdde8a0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports